const messages = {
  en: {
    translations: {
      app: { title: "Numera Builder" },
      errors: { generic: "Something went wrong. Please try again." },
      login: {
        title: "Sign in",
        email: "E-mail",
        password: "Password",
        submit: "Sign in",
        invalid: "Invalid credentials",
      },
      menu: {
        groups: {
          telefonia: "Telephony",
          builder: "Builder",
          integrations: "Integrations",
        },
        dashboard: "Dashboard",
        assistant: "Assistant",
        numbers: "Numbers",
        cdrs: "Calls",
        applications: "Applications",
        templates: "Templates",
        events: "Events",
        connectors: "Connectors",
        datasets: "Tables",
        data: "Data",
        storage: "Storage",
        secrets: "Secrets",
        webhooks: "Webhooks",
        usage: "Uso & Saldo",
        developers: "Developers",
        agents: "AI Agents",
        schedules: "Schedules",
        users: "Users",
        logout: "Log out",
      },
      events: {
        title: "Events",
        clear: "Clear",
        confirmClear: "Delete all events?",
        empty: "No events yet.",
        loadMore: "Load more",
        selectHint: "Select an event to see details.",
        today: "Today",
        yesterday: "Yesterday",
        app: "Application",
        type: "Type",
      },
      apps: {
        title: "Applications",
        new: "New application",
        search: "Search applications",
        empty: "No applications yet. Click \"New application\" to start.",
        name: "Name",
        trigger: "Trigger",
        updatedAt: "Updated",
        lastRunAt: "Last run",
        confirmDelete: "Delete this application?",
        saved: "Application saved.",
        namePlaceholder: "Application name",
        previewJson: "Preview JSON",
        copy: "Copy",
        copied: "JSON copied.",
        copiedShort: "Copied",
        close: "Close",
        status: "Status",
        publish: "Publish",
        published: "Published v{{v}} and deployed.",
        publishedShort: "Published",
        unpublished: "Unpublished",
        unpublishedShort: "unpublished changes",
        draftStatus: "Draft",
        history: "History",
        version: "Version",
        deploy: "Deploy",
        when: "When",
        notes: "Notes",
        live: "Live",
        archived: "Archived",
        restore: "Restore",
        restored: "Version v{{v}} restored to the draft.",
        noVersions: "No published versions yet.",
        saveFirst: "Save the application first.",
        addStep: "Add step",
      },
      vars: {
        title: "Select variable",
        search: "Search variables in scope...",
        select: "Select",
        insert: "Insert variable",
        empty: "Generate a test event on the trigger to see variables.",
        noMatch: "No variables found.",
      },
      triggers: {
        title: "Trigger",
        choose: "Choose a trigger",
        add: "Add trigger",
        change: "Change trigger",
        empty: "No trigger set. Choose how this application is triggered.",
        webhookUrl: "Webhook URL",
        webhookSaveHint: "Save the application to generate the URL.",
        testEvent: "Test event",
        exampleBody: "Example body (JSON)",
        generateTest: "Generate test event",
        invalidJson: "Invalid JSON in the example body.",
        tested: "Test event generated.",
        exports: "Exports (referenceable in the nodes below)",
        tabConfig: "Configure",
        tabEvents: "Events",
        tabResults: "Results",
        noEvents: "No events yet. Use \"Test event\" or call the webhook URL.",
        selectEventHint: "Select an event in the Events tab to see its data.",
        schemaHint: "Example of the fields this trigger receives — use these paths as variables (no real event yet).",
        refresh: "Refresh",
        method: "Method",
        sendTest: "Send request",
        testSent: "Request sent.",
        testHint: "Fires a real request at this application's webhook; the event shows up in the Events tab.",
        inbound_call: {
          title: "On incoming call",
          desc: "Fires when a call arrives on a number linked to this application.",
        },
        webhook: {
          title: "Webhook",
          desc: "Fires when an external system calls a URL (HTTP). Useful to originate calls.",
        },
        scheduled: {
          title: "Scheduled",
          desc: "Fires at defined times (cron expression).",
        },
      },
      numbers: {
        title: "Numbers",
        search: "Search by number or city",
        empty: "No numbers found.",
        number: "Number",
        type: "Type",
        city: "City",
        inbound: "Inbound application",
        outbound: "Outbound application",
        types: { fixo: "Landline", movel: "Mobile" },
        link: "Link applications",
        none: "None",
        linkHint: "Inbound: the flow or agent that answers when someone calls this number. To call from it, pick the number in the Start call node.",
      },
      projects: {
        title: "Projects",
        new: "New project",
        search: "Search projects",
        empty: "No projects found.",
        name: "Name",
        status: "Status",
        owner: "Owner",
        updatedAt: "Updated",
        confirmDelete: "Delete this project?",
        deleted: "Project deleted.",
        saved: "Project saved.",
      },
      status: {
        draft: "Draft",
        active: "Active",
        paused: "Paused",
        archived: "Archived",
      },
      config: {
        back: "Back",
        save: "Save",
        tabs: { general: "General", advanced: "Advanced" },
        fields: {
          name: "Name",
          description: "Description",
          status: "Status",
        },
        validation: { nameRequired: "Name is required" },
      },
    },
  },
};

export { messages };
